import $ from 'jquery';
import createFocusTrap from 'focus-trap/index';
var arrowKey = {
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  esc: 27
};
var mainContainer = '.header-meganav';
var levelOneNav = '[id*="level-one-link"]';
var levelTwoNav = '[id*="-tabs-left"] button.nav-link';
var levelThreeNav = '[id*="-tabs-right"] a, [id*="-tabs-right"] button';

var unfocusAllOthers = function unfocusAllOthers(currentlyFocused) {
  var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var listToUnfocus = [{
    links: levelOneNav,
    id: '1'
  }, {
    links: levelTwoNav,
    id: '2'
  }, {
    links: levelThreeNav,
    id: '3'
  }];
  /* eslint-disable no-return-assign */

  listToUnfocus.filter(function (a) {
    return a.id !== currentlyFocused;
  }).forEach(function (obj) {
    return $("".concat(obj.links)).each(function (ind, el) {
      return el.tabIndex = -1;
    });
  });

  if (reset) {
    listToUnfocus.filter(function (a) {
      return a.id === currentlyFocused;
    }).forEach(function (obj) {
      return $("".concat(obj.links)).each(function (ind, el) {
        return el.tabIndex = 0;
      });
    });
  }
}; // Fake a mousedown event for focus trap deactivation


var triggerMouseEvent = function triggerMouseEvent(el, evt) {
  var clickEvt = document.createEvent('MouseEvents');
  clickEvt.initEvent(evt, true, true);
  el.dispatchEvent(clickEvt);
  $('.tab-focused-el').each(function (ind, elmt) {
    return $(elmt).removeClass('tab-focused-el');
  });
};

var activateFocusTrap = function activateFocusTrap(idOfElToFocus, elToFocus, isActive) {
  var childToFocus = "#".concat(idOfElToFocus, " .").concat($(elToFocus).attr('class').split(' ')[0]).concat(isActive);
  $(childToFocus).focus().addClass('focus-visible');
  var focusTrapOptions = {
    initialFocus: childToFocus,
    clickOutsideDeactivates: true,
    returnFocusOnDeactivate: false,
    onActivate: function onActivate() {
      $(mainContainer).addClass('activated');
    },
    onDeactivate: function onDeactivate() {
      $(mainContainer).removeClass('activated');
    }
  };
  var focusTrap = createFocusTrap("#".concat(idOfElToFocus), focusTrapOptions);
  focusTrap.activate();
};

var findAndFocus = function findAndFocus(element, selector, id) {
  var backToMain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var idOfElToFocus = $(element).attr('id');
  var elToFocus;

  if (backToMain) {
    elToFocus = $(element).find("#".concat(backToMain, "-level-one-link"));
  } else {
    elToFocus = $(element).find("".concat(selector, ".active")).length ? $(element).find("".concat(selector, ".active")).first() : $(element).find("".concat(selector)).first();
  }

  var isActive = $(elToFocus).hasClass('active') ? '.active' : ''; // Make sure no focus trap is activated

  if ($(mainContainer).hasClass('activated')) triggerMouseEvent(document.querySelector(mainContainer), 'mousedown');
  $(elToFocus).addClass('tab-focused-el'); // Add a dummy class for those elms w/o class

  unfocusAllOthers(id, true);

  if (backToMain) {
    setTimeout(function () {
      $(elToFocus).focus().addClass('focus-visible');
    }, 100);
  } else {
    // Focus trap should only activate if inside menu
    activateFocusTrap(idOfElToFocus, elToFocus, isActive);
  }
};

var focusNextItem = function focusNextItem(focusedEl) {
  if (focusedEl.hasClass('nav-link')) {
    var leftTabs = focusedEl.siblings().find('[id*="-tabs-left"]');
    findAndFocus(leftTabs, 'button.nav-link', '2');
  } else if (focusedEl.hasClass('tabs-left')) {
    var activeTab = focusedEl.find('button.active').attr('data-nav-subsection');
    var rightTabs = $("#".concat(activeTab));
    findAndFocus(rightTabs, 'a, button', '3');
  }
};

var focusPreviousItem = function focusPreviousItem(focusedEl) {
  if (focusedEl.hasClass('tabs-left')) {
    var levelOneLinks = focusedEl.parents('.level-1');
    var backToMainAttr = focusedEl.parents('[data-nav-section]').attr('data-nav-section');
    findAndFocus(levelOneLinks, '.nav-link', '1', backToMainAttr);
  } else if (focusedEl.hasClass('tabs-right')) {
    var leftTabs = focusedEl.siblings('[id*="-tabs-left"]');
    findAndFocus(leftTabs, 'button.nav-link', '2');
  }
}; // Reset everything when escape key/close btn is pressed


var closeAndReset = function closeAndReset() {
  var currentDropdown = $('.main-navigation').find('.dropdown-menu.show');
  currentDropdown.dropdown('hide');
  currentDropdown.parents('[data-nav-section]').find($('[id*="-level-one-link"]')).trigger('focus', jQuery.Event('focus')).addClass('focus-visible');
};

var toggleAriaExpandedTabs = function toggleAriaExpandedTabs() {
  $('.header-meganav [id*="-tabs-left"] button[data-toggle="tab"]').each(function (i, e) {
    var subMenuTab = $(e);
    subMenuTab.attr('aria-expanded', function () {
      return subMenuTab.hasClass('active');
    });
  });
};

export default (function () {
  $('[id*="level-one-link"], [id*="-tabs-left"], [id*="-tabs-right"]').on('keydown', function (e) {
    var $e = $(e.currentTarget); // Return if element does not have a dropdown menu to navigate

    if ($e.parent('[data-nav-section]').length && !$e.siblings('.dropdown-menu').length) return;

    switch (e.keyCode) {
      case arrowKey.right:
      case arrowKey.down:
        e.preventDefault();
        e.stopPropagation();
        focusNextItem($e);
        break;

      case arrowKey.left:
      case arrowKey.up:
        e.preventDefault();
        e.stopPropagation();
        focusPreviousItem($e);
        break;

      case arrowKey.esc:
        closeAndReset();
        break;

      default:
        break;
    }
  }); // When left tab is active, give aria expanded attr

  $('.header-meganav [id*="-tabs-left"] button[data-toggle="tab"]').on('click', function () {
    toggleAriaExpandedTabs();
  }); // While menu is showing, keep a blue underline on level 1 nav
  // Remove blue line and reset all focus traps/tabindex when menu is closed

  $('.header-meganav').on('hide.bs.dropdown', '.main-navigation [data-nav-section]', function (e) {
    triggerMouseEvent(document.querySelector(mainContainer), 'mousedown');
    unfocusAllOthers('1', true);
    $(e.currentTarget).removeClass('level-1-focused-line');
  }).on('shown.bs.dropdown', '.main-navigation [data-nav-section]', function (e) {
    $(e.currentTarget).addClass('level-1-focused-line');
  });
  unfocusAllOthers('1');
  toggleAriaExpandedTabs();
});